import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/SecondaryCategorySeoLinks/index.js";
const variants = import.meta.webpackContext("/components/SecondaryCategorySeoLinks", { recursive: true, regExp: /\.\/__variants__\/plp\-filtering\-experience\/v2\/index\.js/ });
export default pointCut({ joinPoint, variants });